(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kosui-cinematic-cart"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initCart = (root) => {
    if (!root || root.dataset.kosuiReady === 'true') return;
    root.dataset.kosuiReady = 'true';
    const header = root.querySelector('[data-kcart-header]');
    const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 32);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
    root.querySelectorAll('[data-cart-line]').forEach((line) => {
      const quantity = line.querySelector('[data-cart-quantity]');
      line.querySelector('[data-cart-minus]')?.addEventListener('click', () => {
        if (quantity) quantity.value = Math.max(0, Number(quantity.value || 0) - 1);
      });
      line.querySelector('[data-cart-plus]')?.addEventListener('click', () => {
        if (quantity) quantity.value = Math.max(1, Number(quantity.value || 0) + 1);
      });
    });
  };
  document.querySelectorAll('[data-kosui-cart]').forEach(initCart);
  document.addEventListener('shopify:section:load', (event) => initCart(event.target.querySelector('[data-kosui-cart]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kosui-cinematic-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initCatalogue = (root) => {
    if (!root || root.dataset.kosuiReady === 'true') return;
    root.dataset.kosuiReady = 'true';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const header = root.querySelector('[data-kc-header]');
    const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 32);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });

    const sort = root.querySelector('[data-kc-sort]');
    sort?.addEventListener('change', () => sort.form?.requestSubmit());

    const reveals = [...root.querySelectorAll('.kc-reveal')];
    if (reduced || !('IntersectionObserver' in window)) {
      reveals.forEach((item) => item.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver((entries, instance) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          instance.unobserve(entry.target);
        });
      }, { threshold: .08, rootMargin: '0px 0px -5% 0px' });
      reveals.forEach((item) => observer.observe(item));
    }

    if (!reduced && window.matchMedia('(pointer: fine)').matches) {
      root.querySelectorAll('[data-kc-card]').forEach((card) => {
        card.addEventListener('pointermove', (event) => {
          const box = card.getBoundingClientRect();
          const rx = ((event.clientY - box.top) / box.height - .5) * -2.5;
          const ry = ((event.clientX - box.left) / box.width - .5) * 3.5;
          card.style.transform = `perspective(1100px) rotateX(${rx.toFixed(2)}deg) rotateY(${ry.toFixed(2)}deg)`;
        });
        card.addEventListener('pointerleave', () => { card.style.transform = ''; });
      });
    }
  };
  document.querySelectorAll('[data-kosui-catalogue]').forEach(initCatalogue);
  document.addEventListener('shopify:section:load', (event) => initCatalogue(event.target.querySelector('[data-kosui-catalogue]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kosui-cinematic-exact"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initKosuiCinematic = (root) => {
    if (!root || root.dataset.kosuiReady === 'true') return;
    root.dataset.kosuiReady = 'true';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const compactLayout = window.matchMedia('(max-width: 760px)');
  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
  const lerp = (from, to, amount) => from + (to - from) * amount;
  const smoothstep = (start, end, value) => {
    const position = clamp((value - start) / (end - start));
    return position * position * (3 - 2 * position);
  };

  const header = root.querySelector('[data-header]');
  const paperSections = [
    root.querySelector('.threshold'),
    root.querySelector('.scent-worlds'),
  ].filter(Boolean);

  const updateHeader = () => {
    header?.classList.toggle('is-scrolled', window.scrollY > 36);
    const sample = window.scrollY + 38;
    const isOnPaper = paperSections.some((section) => {
      const top = section.offsetTop;
      return sample >= top && sample < top + section.offsetHeight;
    });
    header?.classList.toggle('on-paper', isOnPaper);
  };

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
  window.addEventListener('resize', updateHeader);

  const world = root.querySelector('[data-scroll-world]');
  const flightRig = root.querySelector('[data-flight-rig]');
  const scrollFilm = root.querySelector('[data-scroll-film]');
  const filmFrame = scrollFilm?.closest('.flight-frame');
  const heroCopy = root.querySelector('[data-hero-copy]');
  const worldProgress = root.querySelector('[data-world-progress]');
  const worldCount = root.querySelector('[data-world-count]');
  const worldSteps = [...root.querySelectorAll('[data-world-step]')];
  let worldTicking = false;
  let filmReady = false;
  let lastFilmTime = -1;

  const revealScrollFilm = () => {
    if (scrollFilm && scrollFilm.readyState >= 2) {
      filmFrame?.classList.add('is-film-visible');
    }
  };

  scrollFilm?.addEventListener('loadeddata', revealScrollFilm, { once: true });
  scrollFilm?.addEventListener('seeked', revealScrollFilm, { once: true });
  scrollFilm?.addEventListener('error', () => {
    filmFrame?.classList.remove('is-film-visible');
  });

  const setFilmTime = (progress) => {
    if (!scrollFilm || !filmReady || reducedMotion) return;
    const target = progress * Math.max(0.01, scrollFilm.duration - 0.08);
    const minimumStep = compactLayout.matches ? 0.12 : 0.08;
    if (Math.abs(target - lastFilmTime) < minimumStep) return;
    try {
      scrollFilm.currentTime = target;
      lastFilmTime = target;
    } catch {
    }
  };

  const updateWorld = () => {
    worldTicking = false;
    if (!world || !flightRig) return;

    const bounds = world.getBoundingClientRect();
    const travel = Math.max(1, bounds.height - window.innerHeight);
    const progress = clamp(-bounds.top / travel);
    world.style.setProperty('--world-progress', progress.toFixed(4));

    if (worldProgress) {
      worldProgress.style.transform = `scaleX(${progress.toFixed(4)})`;
    }
    if (worldCount) {
      worldCount.textContent = String(Math.round(progress * 100)).padStart(2, '0');
    }

    const introFade = 1 - smoothstep(0.09, 0.24, progress);
    if (heroCopy) {
      heroCopy.style.opacity = introFade.toFixed(3);
      heroCopy.style.transform = compactLayout.matches
        ? `translate3d(0, ${lerp(0, -26, 1 - introFade)}px, 0)`
        : `translate3d(0, calc(-48% + ${lerp(0, -34, 1 - introFade)}px), 0)`;
      heroCopy.style.pointerEvents = introFade < 0.15 ? 'none' : 'auto';
    }

    const approach = smoothstep(0.02, 0.66, progress);
    const passThrough = smoothstep(0.64, 1, progress);
    const isCompact = compactLayout.matches;
    const startX = isCompact ? -43 : 10;
    const focusX = isCompact ? -43 : -9;
    const exitX = isCompact ? -43 : -36;
    const x = lerp(lerp(startX, focusX, approach), exitX, passThrough);
    const y = lerp(0, isCompact ? 3 : -2.5, approach) + lerp(0, -5, passThrough);
    const z = lerp(0, 120, approach) + lerp(0, 520, passThrough);
    const scale = lerp(0.92, isCompact ? 1.06 : 1.25, approach) + lerp(0, isCompact ? 1.12 : 1.4, passThrough);
    const rotateY = lerp(isCompact ? -2 : -8, 5, approach) + lerp(0, -7, passThrough);
    const rotateX = lerp(2, -1.8, approach);
    const flightOpacity = 1 - smoothstep(0.91, 1, progress);

    flightRig.style.transform =
      `translate3d(${x.toFixed(3)}vw, calc(-50% + ${y.toFixed(2)}vh), ${z.toFixed(1)}px) ` +
      `rotateX(${rotateX.toFixed(2)}deg) rotateY(${rotateY.toFixed(2)}deg) scale(${scale.toFixed(3)})`;
    flightRig.style.opacity = flightOpacity.toFixed(3);
    flightRig.style.filter = `blur(${lerp(0, 4, smoothstep(0.9, 1, progress)).toFixed(2)}px)`;

    worldSteps.forEach((step) => {
      const start = Number(step.dataset.start);
      const end = Number(step.dataset.end);
      const local = clamp((progress - start) / (end - start));
      const opacity = smoothstep(0, 0.18, local) * (1 - smoothstep(0.72, 1, local));
      step.style.opacity = opacity.toFixed(3);
      step.style.transform = `translate3d(0, ${lerp(28, -14, local).toFixed(1)}px, 0)`;
    });

    setFilmTime(progress);
  };

  const requestWorldUpdate = () => {
    if (worldTicking || reducedMotion) return;
    worldTicking = true;
    requestAnimationFrame(updateWorld);
  };

  const activateScrollFilm = () => {
    filmReady = Boolean(
      scrollFilm && Number.isFinite(scrollFilm.duration) && scrollFilm.duration > 0,
    );
    if (!filmReady || reducedMotion) return;
    lastFilmTime = -1;
    scrollFilm.muted = true;
    scrollFilm.setAttribute('playsinline', '');
    scrollFilm.setAttribute('webkit-playsinline', '');

    const finishPrime = (canReveal) => {
      scrollFilm.pause();
      updateWorld();
      if (!canReveal) return;
      if ('requestVideoFrameCallback' in scrollFilm) {
        scrollFilm.requestVideoFrameCallback(revealScrollFilm);
      } else {
        requestAnimationFrame(revealScrollFilm);
      }
    };
    const playAttempt = scrollFilm.play();
    if (playAttempt && typeof playAttempt.then === 'function') {
      playAttempt.then(() => finishPrime(true)).catch(() => finishPrime(false));
    } else {
      finishPrime(true);
    }
  };

  if (scrollFilm) {
    if (scrollFilm.readyState >= 1) {
      activateScrollFilm();
    } else {
      scrollFilm.addEventListener('loadedmetadata', activateScrollFilm, { once: true });
    }
  }

  if (!reducedMotion) {
    updateWorld();
    window.addEventListener('scroll', requestWorldUpdate, { passive: true });
    window.addEventListener('resize', requestWorldUpdate);
  } else {
    scrollFilm?.pause();
  }

  const revealItems = [...root.querySelectorAll('.reveal')];
  if (reducedMotion || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  } else {
    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -7% 0px' },
    );
    revealItems.forEach((item) => revealObserver.observe(item));
  }

  const ambientVideos = [...root.querySelectorAll('[data-ambient-video]')];
  if (reducedMotion) {
    root.querySelectorAll('video').forEach((video) => video.pause());
  } else if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => undefined);
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.18 },
    );
    ambientVideos.forEach((video) => videoObserver.observe(video));
  }

  const orbitStage = root.querySelector('[data-orbit-stage]');
  const orbitCards = [...root.querySelectorAll('[data-product-card]')];
  const orbitJumps = [...root.querySelectorAll('[data-orbit-jump]')];
  const orbitPrev = root.querySelector('[data-orbit-prev]');
  const orbitNext = root.querySelector('[data-orbit-next]');
  const orbitCurrent = root.querySelector('[data-orbit-current]');
  const orbitName = root.querySelector('[data-orbit-name]');
  let activeProduct = 0;
  let dragStart = null;
  let mobileScrollTicking = false;

  const wrappedOffset = (index, active, total) => {
    let offset = index - active;
    if (offset > total / 2) offset -= total;
    if (offset < -total / 2) offset += total;
    return offset;
  };

  const renderOrbit = ({ scrollMobile = false } = {}) => {
    if (!orbitStage || orbitCards.length === 0) return;
    const compact = compactLayout.matches;
    const spacing = Math.min(300, orbitStage.clientWidth * 0.29);

    orbitCards.forEach((card, index) => {
      const offset = wrappedOffset(index, activeProduct, orbitCards.length);
      const distance = Math.abs(offset);
      card.classList.toggle('is-active', index === activeProduct);
      card.setAttribute('aria-hidden', compact ? 'false' : String(distance > 2));
      card.style.setProperty('--card-x', `${(offset * spacing).toFixed(1)}px`);
      card.style.setProperty('--card-y', `${(distance * 18).toFixed(1)}px`);
      card.style.setProperty('--card-z', `${(-distance * 220).toFixed(1)}px`);
      card.style.setProperty('--card-rotate', `${(offset * -20).toFixed(1)}deg`);
      card.style.setProperty('--card-scale', String(Math.max(0.58, 1 - distance * 0.13)));
      card.style.setProperty('--card-opacity', String(distance > 2.2 ? 0 : Math.max(0.14, 1 - distance * 0.3)));
    });

    orbitJumps.forEach((button, index) => {
      button.classList.toggle('is-current', index === activeProduct);
      button.setAttribute('aria-pressed', String(index === activeProduct));
    });

    if (orbitCurrent) orbitCurrent.textContent = String(activeProduct + 1).padStart(2, '0');
    if (orbitName) orbitName.textContent = orbitCards[activeProduct]?.dataset.name || '';

    if (compact && scrollMobile) {
      orbitCards[activeProduct]?.scrollIntoView({
        behavior: reducedMotion ? 'auto' : 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }
  };

  const setActiveProduct = (nextIndex, options) => {
    activeProduct = (nextIndex + orbitCards.length) % orbitCards.length;
    renderOrbit(options);
  };

  orbitPrev?.addEventListener('click', () => setActiveProduct(activeProduct - 1));
  orbitNext?.addEventListener('click', () => setActiveProduct(activeProduct + 1));
  orbitJumps.forEach((button, index) => {
    button.addEventListener('click', () => setActiveProduct(index, { scrollMobile: true }));
  });

  orbitStage?.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      setActiveProduct(activeProduct - 1, { scrollMobile: true });
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      setActiveProduct(activeProduct + 1, { scrollMobile: true });
    }
  });

  orbitStage?.addEventListener('pointerdown', (event) => {
    if (compactLayout.matches) return;
    dragStart = event.clientX;
    orbitStage.setPointerCapture?.(event.pointerId);
  });

  orbitStage?.addEventListener('pointerup', (event) => {
    if (dragStart === null || compactLayout.matches) return;
    const distance = event.clientX - dragStart;
    dragStart = null;
    if (Math.abs(distance) < 42) return;
    setActiveProduct(activeProduct + (distance < 0 ? 1 : -1));
  });

  orbitStage?.addEventListener('pointercancel', () => {
    dragStart = null;
  });

  const carousel = root.querySelector('[data-orbit-carousel]');
  carousel?.addEventListener(
    'scroll',
    () => {
      if (!compactLayout.matches || mobileScrollTicking) return;
      mobileScrollTicking = true;
      requestAnimationFrame(() => {
        mobileScrollTicking = false;
        const stageCenter = carousel.getBoundingClientRect().left + carousel.clientWidth / 2;
        let nearest = activeProduct;
        let nearestDistance = Infinity;
        orbitCards.forEach((card, index) => {
          const bounds = card.getBoundingClientRect();
          const distance = Math.abs(bounds.left + bounds.width / 2 - stageCenter);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearest = index;
          }
        });
        if (nearest !== activeProduct) {
          activeProduct = nearest;
          renderOrbit();
        }
      });
    },
    { passive: true },
  );

  renderOrbit();
  window.addEventListener('resize', () => renderOrbit());
  compactLayout.addEventListener?.('change', () => renderOrbit());

  if (!reducedMotion && window.matchMedia('(hover: hover)').matches) {
    root.querySelectorAll('[data-card-tilt]').forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const bounds = card.getBoundingClientRect();
        const x = ((event.clientX - bounds.left) / bounds.width - 0.5) * 2;
        const y = ((event.clientY - bounds.top) / bounds.height - 0.5) * 2;
        card.style.setProperty('--tilt-x', `${(x * 5).toFixed(2)}deg`);
        card.style.setProperty('--tilt-y', `${(y * -5).toFixed(2)}deg`);
      });
      card.addEventListener('pointerleave', () => {
        card.style.setProperty('--tilt-x', '0deg');
        card.style.setProperty('--tilt-y', '0deg');
      });
    });
  }
  };

  document.querySelectorAll('[data-kosui-cinematic]').forEach(initKosuiCinematic);
  document.addEventListener('shopify:section:load', (event) => {
    initKosuiCinematic(event.target.querySelector('[data-kosui-cinematic]'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kosui-cinematic-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));

    const initKosui = (root) => {
      if (!root || root.dataset.ksBound === 'true') return;
      root.dataset.ksBound = 'true';

      const story = root.querySelector('[data-scroll-story]');
      const frame = root.querySelector('[data-film-frame]');
      const scenes = [...root.querySelectorAll('[data-scene]')];
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeScene = -1;
      let ticking = false;

      const setScene = (next) => {
        if (next === activeScene) return;
        activeScene = next;
        scenes.forEach((scene) => scene.classList.toggle('is-active', Number(scene.dataset.scene) === next));
      };

      const renderStory = () => {
        ticking = false;
        if (!story || !frame) return;
        const rect = story.getBoundingClientRect();
        const travel = Math.max(1, story.offsetHeight - window.innerHeight);
        const progress = reducedMotion ? 0 : clamp(-rect.top / travel);
        const frameIndex = Math.round(progress * 59);
        const col = frameIndex % 10;
        const row = Math.floor(frameIndex / 10);
        const x = (col / 9) * 100;
        const y = (row / 5) * 100;

        root.style.setProperty('--ks-progress', progress.toFixed(4));
        frame.style.backgroundPosition = `${x}% ${y}%`;

        if (progress < .22) setScene(0);
        else if (progress < .48) setScene(1);
        else if (progress < .75) setScene(2);
        else setScene(3);
      };

      const requestRender = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(renderStory);
      };

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender, { passive: true });
      renderStory();

      const observer = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              }
            });
          }, { threshold: .12, rootMargin: '0px 0px -6% 0px' })
        : null;

      root.querySelectorAll('.ks-reveal').forEach((element) => {
        if (observer) observer.observe(element);
        else element.classList.add('is-visible');
      });

      if (!reducedMotion && window.matchMedia('(pointer: fine)').matches) {
        root.querySelectorAll('[data-tilt]').forEach((card) => {
          card.addEventListener('pointermove', (event) => {
            const rect = card.getBoundingClientRect();
            const px = (event.clientX - rect.left) / rect.width;
            const py = (event.clientY - rect.top) / rect.height;
            card.style.setProperty('--ry', `${(px - .5) * 7}deg`);
            card.style.setProperty('--rx', `${(.5 - py) * 7}deg`);
          });
          card.addEventListener('pointerleave', () => {
            card.style.setProperty('--ry', '0deg');
            card.style.setProperty('--rx', '0deg');
          });
        });
      }

      const rail = root.querySelector('[data-product-rail]');
      if (rail && window.matchMedia('(pointer: fine)').matches) {
        let dragging = false;
        let startX = 0;
        let startScroll = 0;
        rail.addEventListener('pointerdown', (event) => {
          if (event.target.closest('button, a')) return;
          dragging = true;
          startX = event.clientX;
          startScroll = rail.scrollLeft;
          rail.classList.add('is-dragging');
          rail.setPointerCapture(event.pointerId);
        });
        rail.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          rail.scrollLeft = startScroll - (event.clientX - startX) * 1.25;
        });
        const stopDrag = () => {
          dragging = false;
          rail.classList.remove('is-dragging');
        };
        rail.addEventListener('pointerup', stopDrag);
        rail.addEventListener('pointercancel', stopDrag);
      }
    };

    document.querySelectorAll('[data-kosui-home]').forEach(initKosui);
    document.addEventListener('shopify:section:load', (event) => {
      initKosui(event.target.querySelector('[data-kosui-home]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kosui-cinematic-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initProduct = (root) => {
    if (!root || root.dataset.kosuiReady === 'true') return;
    root.dataset.kosuiReady = 'true';
    const header = root.querySelector('[data-kp-header]');
    const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 32);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });

    const quantity = root.querySelector('[data-kp-quantity]');
    root.querySelector('[data-kp-minus]')?.addEventListener('click', () => { if (quantity) quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
    root.querySelector('[data-kp-plus]')?.addEventListener('click', () => { if (quantity) quantity.value = Math.max(1, Number(quantity.value || 1) + 1); });

    const variant = root.querySelector('[data-kp-variant]');
    const price = root.querySelector('[data-kp-price]');
    const compare = root.querySelector('[data-kp-compare]');
    const add = root.querySelector('[data-kp-add]');
    const addLabel = root.querySelector('[data-kp-add-label]');
    variant?.addEventListener('change', () => {
      const option = variant.selectedOptions[0];
      if (price) price.textContent = option.dataset.price || '';
      if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
      const available = option.dataset.available === 'true';
      if (add) add.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';
    });

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const stage = root.querySelector('[data-kp-tilt]');
    if (!reduced && stage && window.matchMedia('(pointer: fine)').matches) {
      stage.addEventListener('pointermove', (event) => {
        const box = stage.getBoundingClientRect();
        const rx = ((event.clientY - box.top) / box.height - .5) * -3;
        const ry = ((event.clientX - box.left) / box.width - .5) * 4;
        stage.style.transform = `perspective(1400px) rotateX(${rx.toFixed(2)}deg) rotateY(${ry.toFixed(2)}deg)`;
      });
      stage.addEventListener('pointerleave', () => { stage.style.transform = ''; });
    }
  };
  document.querySelectorAll('[data-kosui-product-page]').forEach(initProduct);
  document.addEventListener('shopify:section:load', (event) => initProduct(event.target.querySelector('[data-kosui-product-page]')));
})();

  } catch(e) { console.error(e); }
})();
})();
